import VectorSource from 'ol/source/Vector'
import GeoJSON from 'ol/format/GeoJSON'
import { Vector as VectorLayer } from 'ol/layer'
import { Fill, Stroke, Style } from 'ol/style'
import { chunk } from 'lodash'

/* global axios */
const kulturarvOmraden = ({ kommun, type, byggnadsInvIds }) => {
  const onByggnadsInventering = _.includes(window.location.pathname, 'byggnadsinventering')
  const typeName = type || `view_kulturarv_omraden_${kommun.toLowerCase()}`
  const source = new VectorSource({
    format: new GeoJSON(),
    projection: 'EPSG:3857',
    loader: function (extent, resolution, projection) {
      var proj = projection.getCode()

      const parts = typeName.split('_')
      const municipality = parts.slice(2).join('_')

      if (byggnadsInvIds) {
        let filteredByggnadsInvIds = _.isEmpty(byggnadsInvIds) || byggnadsInvIds[0][0] === "''" ? [["''"]] : byggnadsInvIds.filter(id => id.includes(municipality))
        if (_.isEmpty(filteredByggnadsInvIds)) {
          filteredByggnadsInvIds = [["''"]]
        }

        filteredByggnadsInvIds = chunk(filteredByggnadsInvIds, 30)

        const promises = _.map(filteredByggnadsInvIds, (ids, index) => {
          return axios.post(`${process.env.MIX_ASSET_URL}/api/ltv/wfs`, {
            typeName,
            srsname: proj,
            outputFormat: 'application/json',
            cql_filter: _.isEmpty(ids) ? null : `byggnadsid IN (${ids.join(',')})`
          // bbox: extent.join(',') + ',' + proj
          })
        })

        axios.all(promises).then(axios.spread((...responses) => {
          const data = _.map(responses, response => response.data)
          const featureCollection = {
            type: 'FeatureCollection',
            features: []
          }

          _.forEach(data, (featureCollectionResponse, index) => {
            featureCollection.features = featureCollection.features.concat(featureCollectionResponse.features)
          })

          source.addFeatures(source.getFormat().readFeatures(featureCollection))
        }))
      } else {
        axios.post(`${process.env.MIX_ASSET_URL}/api/ltv/wfs`, {
          typeName,
          srsname: proj,
          outputFormat: 'application/json'
          // cql_filter: _.isEmpty(filteredByggnadsInvIds) ? null : `byggnadsid IN (${filteredByggnadsInvIds.join(',')})`
        // bbox: extent.join(',') + ',' + proj
        })
          .then(response => response.data)
          .then(text => {
            source.addFeatures(source.getFormat().readFeatures(text))
          })
      }
    }
    // strategy: bboxStrategy
  })

  const layer = new VectorLayer({
    className: 'kulturarvOmradenLayer',
    zIndex: 1,
    source: source,
    minResolution: 2,
    maxResolution: 120,
    style: function (feature) {
      const mFeature = new GeoJSON().writeFeatureObject(feature)
      return onByggnadsInventering &&
      _.includes(window.location.pathname, mFeature.properties.byggnadsid)
        ? new Style({
          stroke: new Stroke({
            color: 'rgb(221,137,1)',
            width: 3
          }),
          fill: new Fill({
            color: 'rgba(221,137,1,0.7)'
          })
        })
        : new Style({
          stroke: new Stroke({
            color: 'rgba(254,146,0,.4)',
            width: 2
          }),
          fill: new Fill({
            color: 'rgba(254,146,0,.3)'
          })
        })
    }
  })

  layer.setSource(source)

  return layer
}

export default kulturarvOmraden
